import layout from '@/layout/default.vue';

export default [{
  path: 'commercial',
  redirect: 'commercial/list',
  component: layout,
  children: [{
    path: 'list',
    component: () => import('@/views/project/commercial/list.vue')
  }]
}];
